import '@swf/engine/src/css/main.scss';
import '@swf/engine/src/css/sw-lightTheme.scss';

// Admin module
import './acc/admin/des-catalog-consent-page';
import './acc/admin/des-catalog-status-logs'

// Team Module
import './acc/team/des-collab-create-team';
import './acc/team/des-create-team-main-panel';
import './acc/team/des-create-team-sub-panel';
import './acc/team/des-collab-edit-team';
import './acc/team/des-edit-team-main-panel';
import './acc/team/des-edit-team-sub-panel';
import './acc/team/des-team-list';
import './acc/team/des-team-contents';
import './acc/team/des-user-list';
import { registerDynImportEntry } from 'js/moduleLoader';

// Search Module
import './acc/search/des-catalog-search-box';
import './acc/search/des-search-filter';
import './acc/search/des-catalog-search-results';
import './acc/search/des-catalog-progress-bar';
import './acc/search/des-breadcrumb';

// Catalog module
import './acc/catalog/des-download';
import './acc/catalog/des-catalog-images-view';
import './acc/catalog/des-catalog-part-summary';
import './acc/catalog/des-catalog-part-list';
import './acc/catalog/des-webgl-viewer';
import './acc/catalog/des-add-part-to-library';
import './acc/catalog/des-catalog-part-pdf-viewer';
import './acc/catalog/des-image-viewer';
import './acc/catalog/des-jt-viewer';
import './acc/catalog/des-catalog-carousel';
import './acc/catalog/des-catalog-properties';
import './acc/catalog/des-catalog-navigation';
import './acc/catalog/des-catalog-part-config';

//Library module
import './acc/library/des-create-library';
import './acc/library/des-update-library';
import './acc/library/des-create-library-folder';
import './acc/library/des-library-members-list';
import './acc/library/des-library-list';
import './acc/library/des-create-library-component';
import './acc/library/des-library-properties';
import './acc/library/des-use-part';
import './acc/library/des-list-library-overview';
import './acc/library/des-library-preview';
import './acc/library/des-share-library-to-teams';
import './acc/library/des-share-library-to-users';
import './acc/library/des-share-library-search-box';
import './acc/library/des-share-library-search-results-for-users';
import './acc/library/des-share-library-search-results-for-teams';
import './acc/library/des-navigate-content-as-list';
import './acc/library/des-library-publish';
import './acc/library/des-upload-supplier-content-in-library';
import './acc/library/des-library-component-revisions';
import './acc/library/des-list-library-content';

// File upload sample
import './acc/library/des-file-upload-sample';

registerDynImportEntry( `viewmodel/ExtendedTooltipDefaultViewModel`, () => import( `viewmodel/ExtendedTooltipDefaultViewModel` ) );
registerDynImportEntry( `viewmodel/AwPopupCommandBarViewModel`, () => import( `viewmodel/AwPopupCommandBarViewModel` ) );
registerDynImportEntry(`viewmodel/AwTableCommandBarViewModel`, () => import(`viewmodel/AwTableCommandBarViewModel`));
registerDynImportEntry(`viewmodel/DesCatalogSearchResultsViewModel`, () => import(`viewmodel/DesCatalogSearchResultsViewModel`));
registerDynImportEntry(`viewmodel/DesCatalogImagesViewViewModel`, () => import(`viewmodel/DesCatalogImagesViewViewModel`));
registerDynImportEntry(`viewmodel/DesCatalogPartPdfViewerViewModel`, () => import(`viewmodel/DesCatalogPartPdfViewerViewModel`));
registerDynImportEntry(`viewmodel/DesWebglViewModel`, () => import(`viewmodel/DesWebglViewModel`));
registerDynImportEntry(`viewmodel/DesImageViewerViewModel`, () => import(`viewmodel/DesImageViewerViewModel`));
registerDynImportEntry(`viewmodel/DesJTViewerViewModel`, () => import(`viewmodel/DesJTViewerViewModel`));
registerDynImportEntry(`viewmodel/AwLinkPopupMenuViewModel`, () => import(`viewmodel/AwLinkPopupMenuViewModel`));


// Part Family Configuration
registerDynImportEntry(`viewmodel/SplmTableCellEditorViewModel`, () => import(`viewmodel/SplmTableCellEditorViewModel`));
registerDynImportEntry(`viewmodel/CustomLOVComponentViewModel`, () => import(`viewmodel/CustomLOVComponentViewModel`));


// Drag and Drop service
registerDynImportEntry(`js/DragDropService`, () => import(`js/DragDropService`));

// Images
registerDynImportEntry(`image/miscDownArrow_uxRefresh12.svg`, () => import(`image/miscDownArrow_uxRefresh12.svg`));
registerDynImportEntry(`image/miscChevronLeft24.svg`, () => import(`image/miscChevronLeft24.svg`));
registerDynImportEntry(`image/miscChevronRight16.svg`, () => import(`image/miscChevronRight16.svg`));
registerDynImportEntry(`image/cmdMore16.svg`, () => import(`image/cmdMore16.svg`));